module.exports = __webpack_public_path__ + "static/media/DSCF0034.dc4f611d.jpg";